export const RULE_SEARCH_PLACEHOLDER =
  'Search by Automation Name or Device Name'
export const RULE_SEARCH_FILTER_LABEL = 'Automation or device name contains.'
